import React from 'react';

const BadgeGooglePlay = () => {
  return (
    <div className="badge-googleplay">
      <a
        href="https://play.google.com/store/apps/details?id=com.clicrbs.jornais"
        target="_blank"
        rel="noopener noreferrer"
        title="Baixe o aplicativo GaúchaZH no Google Play"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="150"
          height="60"
          viewBox="0 0 156 60"
        >
          <defs>
            <linearGradient
              id="a"
              x1="61.034%"
              x2="26.503%"
              y1="4.948%"
              y2="71.907%"
            >
              <stop offset="0%" stopColor="#00A0FF" />
              <stop offset="1%" stopColor="#00A1FF" />
              <stop offset="26%" stopColor="#00BEFF" />
              <stop offset="51%" stopColor="#00D2FF" />
              <stop offset="76%" stopColor="#00DFFF" />
              <stop offset="100%" stopColor="#00E3FF" />
            </linearGradient>
            <linearGradient
              id="b"
              x1="107.685%"
              x2="-130.64%"
              y1="50%"
              y2="50%"
            >
              <stop offset="0%" stopColor="#FFE000" />
              <stop offset="41%" stopColor="#FFBD00" />
              <stop offset="78%" stopColor="#FFA500" />
              <stop offset="100%" stopColor="#FF9C00" />
            </linearGradient>
            <linearGradient
              id="c"
              x1="86.219%"
              x2="-50.15%"
              y1="30.911%"
              y2="135.988%"
            >
              <stop offset="0%" stopColor="#FF3A44" />
              <stop offset="100%" stopColor="#C31162" />
            </linearGradient>
            <linearGradient
              id="d"
              x1="-18.754%"
              x2="42.121%"
              y1="-11.832%"
              y2="35.095%"
            >
              <stop offset="0%" stopColor="#32A071" />
              <stop offset="7%" stopColor="#2DA771" />
              <stop offset="48%" stopColor="#15CF74" />
              <stop offset="80%" stopColor="#06E775" />
              <stop offset="100%" stopColor="#00F076" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(.5)">
            <path d="M0 0h155v60H0z" />
            <rect
              width="135"
              height="40"
              x="10"
              y="10"
              fill="#000"
              fillRule="nonzero"
              rx="5"
            />
            <path
              fill="#A6A6A6"
              fillRule="nonzero"
              d="M140 10.8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H15a4.2 4.2 0 0 1-4.2-4.2V15a4.2 4.2 0 0 1 4.2-4.2h125zm0-.8H15a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M78.14 31.75A4.25 4.25 0 1 0 82.41 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.31-6.83A4.25 4.25 0 1 0 73.09 36a4.19 4.19 0 0 0-4.27-4.25h.01zm0 6.83A2.58 2.58 0 1 1 71.22 36a2.46 2.46 0 0 1-2.4 2.58h.01zm-11.09-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.33 1.32 4.8 4.8 0 1 1 0-9.6A4.6 4.6 0 0 1 61 30.14l1.27-1.27A6.29 6.29 0 0 0 57.74 27a6.61 6.61 0 1 0 0 13.21 6 6 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.22 5.87 5.87 0 0 0-.1-1.13l-6.07.05zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.16 4.16 0 0 0 4.22 4.25 4.23 4.23 0 0 0 3.54-1.88l-1.45-1a2.43 2.43 0 0 1-2.09 1.18 2.16 2.16 0 0 1-2.06-1.29l5.69-2.35-.21-.45zm-5.8 1.42a2.33 2.33 0 0 1 2.22-2.48 1.65 1.65 0 0 1 1.58.9l-3.8 1.58zM92.63 40h1.87V27.5h-1.87V40zm-3.06-7.3h-.07a3 3 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.9 2.9 0 0 0 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.14-1.51l-1.63.68A4.05 4.05 0 0 0 87.29 44c2.19 0 4-1.29 4-4.43V32h-1.72v.7zm-2.14 5.88a2.59 2.59 0 0 1 0-5.16A2.4 2.4 0 0 1 89.7 36a2.38 2.38 0 0 1-2.28 2.58h.01zm24.38-11.08h-4.47V40h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76h-.01zm0 6h-2.61v-4.26h2.65a2.145 2.145 0 1 1 0 4.29l-.04-.03zm11.53-1.8a3.5 3.5 0 0 0-3.33 1.91l1.66.69a1.77 1.77 0 0 1 1.7-.92 1.8 1.8 0 0 1 2 1.61v.13a4.13 4.13 0 0 0-1.95-.48c-1.79 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3.1 2.75 2.63 2.63 0 0 0 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46l-.05-.03zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.19 2l-.05-.03zM133.74 32l-2.14 5.42h-.06L129.32 32h-2l3.33 7.58-1.9 4.21h1.95L135.82 32h-2.08zm-16.81 8h1.87V27.5h-1.87V40z"
            />
            <path
              fill="url(#a)"
              fillRule="nonzero"
              d="M20.44 17.54a2 2 0 0 0-.46 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07L32.9 30.15v-.29L20.51 17.47l-.07.07z"
            />
            <path
              fill="url(#b)"
              fillRule="nonzero"
              d="M37 34.28l-4.1-4.13v-.29l4.1-4.14.09.05L42 28.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.11.05z"
            />
            <path
              fill="url(#c)"
              fillRule="nonzero"
              d="M37.12 34.22L32.9 30 20.44 42.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3"
            />
            <path
              fill="url(#d)"
              fillRule="nonzero"
              d="M37.12 25.78l-14.61-8.3a1.63 1.63 0 0 0-2.08.06L32.9 30l4.22-4.22z"
            />
            <path
              fill="#000"
              fillRule="nonzero"
              d="M37 34.13l-14.49 8.25a1.67 1.67 0 0 1-2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3-.12-.09z"
              opacity=".2"
            />
            <path
              fill="#000"
              fillRule="nonzero"
              d="M20.44 42.32a2 2 0 0 1-.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07-.07-.08zM42 31.3l-5 2.83.09.09L42 31.44A1.75 1.75 0 0 0 43 30a1.86 1.86 0 0 1-1 1.3z"
              opacity=".12"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M22.51 17.62L42 28.7a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0-1-1.44L22.51 17.48c-1.4-.79-2.54-.13-2.54 1.47v.15c.03-1.61 1.15-2.27 2.54-1.48z"
              opacity=".25"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              stroke="#FFF"
              strokeWidth=".2"
              d="M51.34 23v-6h1.84a3 3 0 0 1 2.21.83c.56.58.856 1.365.82 2.17a2.94 2.94 0 0 1-.83 2.17 3 3 0 0 1-2.21.83h-1.83zm.77-.74h1.06a2.25 2.25 0 0 0 1.65-.6 2.23 2.23 0 0 0 .61-1.66 2.09 2.09 0 0 0-2.25-2.26h-1.07v4.52zm5.19.74v-6h.77v6h-.77zm3.83.13a2.24 2.24 0 0 1-1.28-.43 2 2 0 0 1-.82-1.2l.7-.28c.08.323.258.613.51.83.24.22.554.34.88.34a1.4 1.4 0 0 0 .86-.26.84.84 0 0 0 .36-.72.92.92 0 0 0-.36-.77 3.69 3.69 0 0 0-1.13-.51 3 3 0 0 1-1.21-.65 1.36 1.36 0 0 1-.41-1c0-.43.187-.838.51-1.12.363-.328.84-.5 1.33-.48a1.93 1.93 0 0 1 1.24.38c.285.208.501.497.62.83l-.7.29a1 1 0 0 0-.37-.53 1.31 1.31 0 0 0-1.53 0 .75.75 0 0 0-.31.62.7.7 0 0 0 .29.57c.258.184.545.323.85.41.252.08.499.173.74.28.212.099.413.22.6.36.198.141.356.33.46.55.11.242.164.505.16.77a1.65 1.65 0 0 1-.18.78 1.46 1.46 0 0 1-.48.54 2.37 2.37 0 0 1-.64.31 2.4 2.4 0 0 1-.69.09zM65 23h-.77v-6h2a1.9 1.9 0 0 1 1.32.51 1.74 1.74 0 0 1 0 2.56 1.89 1.89 0 0 1-1.32.51H65V23zm0-3.17h1.3a1 1 0 0 0 .78-.33 1 1 0 0 0 0-1.44 1 1 0 0 0-.78-.33H65v2.1zm9 2.39a3.12 3.12 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.4 0 3.23 3.23 0 0 1 0 4.45zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0-3.26 0 2.56 2.56 0 0 0 0 3.44zM76 23v-6h.94l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23H76zm6 0v-6h.77v6H82zm.72-6.47h-.67l.44-1.07h.84l-.61 1.07zM85.64 23l-2.11-6h.85L86 21.87 87.77 17h.85l-2.18 6h-.8zM93 17.74h-2.74v1.9h2.46v.72h-2.46v1.9H93V23h-3.5v-6H93v.74zM94.2 23v-6h.8v5.26h2.6V23h-3.4zm6.35 0v-6h.94l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23h-.78zm10.91-.78a3.12 3.12 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.4 0 3.23 3.23 0 0 1 0 4.45zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0-3.26 0 2.56 2.56 0 0 0 0 3.44z"
            />
          </g>
        </svg>
      </a>
    </div>
  );
};

export default BadgeGooglePlay;
